interface Props {
  name: string;
  icon: string;
  url?: string;
}

const IconWithHyperlink = ({ name, icon, url }: Props) => {
  const renderIcon = () => {
    return <img src={icon} alt={name} />;
  };

  const displayIconWithHyperlink = () => {
    if (icon && url) {
      return (
        <a href={url} target="_blank" rel="noreferrer">
          {renderIcon()}
        </a>
      );
    }
    return renderIcon();
  };

  return displayIconWithHyperlink();
};

export default IconWithHyperlink;
